import { render, staticRenderFns } from "./p3.vue?vue&type=template&id=2a098245&scoped=true&"
import script from "./p3.vue?vue&type=script&lang=js&"
export * from "./p3.vue?vue&type=script&lang=js&"
import style0 from "./p3.vue?vue&type=style&index=0&id=2a098245&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a098245",
  null
  
)

export default component.exports